import styled from "styled-components"
import { TABLET_MAX_WIDTH } from "@constants"
import { Link } from "gatsby"

export const StyledSlash = styled.span`
  color: rgba(196, 177, 128, 0.3);
`

export const StyledOtherArticlesWrapper = styled.div`
  border-top: 1px solid rgba(196, 177, 128, 0.6);
  margin-top: 48px;
`

export const StyledOtherArticleContainer = styled.div`
  margin-top: 32px;
`

export const StyledOtherArticleInformationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledOtherArticleInformationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledOtherArticleAuthorImage = styled.img`
  height: 24px;
  width: 24px !important;
  border-radius: 50%;
`

export const StyledOtherArticleAuthorName = styled.span`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledOtherArticleCreationDate = styled.span`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledOtherArticleCategory = styled.p`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;
`

export const StyledOtherArticleTitle = styled.p`
  color: #252525;
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.56px;
  cursor: pointer;
  margin: 18.76px 0px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    color: rgba(37, 37, 37, 0.80);
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0.4px;
    font-weight: 700;
    margin: 13.4px 0;
}
`

export const StyledOtherArticleMotivationContainer = styled.div``

export const StyledOtherArticleMotivation = styled.span`
  color: rgba(37, 37, 37, 0.8);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.8px;

  @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
    color: #252525;
}
`
export const StyledOtherArticlesTitle = styled.p`
  margin-top: 26px;
  color: rgba(37, 37, 37, 0.8);
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.8px;
`
export const StyledLink = styled(Link)`
  text-decoration: none;
`;

export const StyledTabletOtherArticlesWrapper = styled.div``;

export const StyledTabletOtherArticlesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 40px;
`;

export const StyledOtherArticleAuthorImageContainer = styled.div``;
